export const config = {
    api_base: 'https://prod.diningtek.com/api/v1',
    api_root : 'https://prod.diningtek.com',
    logo_img_root : '/img/jaipur-india-logo.png',
    banner_img_root : '/img/world-cafe-banner-2.png',
    resid : '2cef034950a1d18c2aea65311bcc758c',
    key_value : 'latenightjaipurindianrestaurant',
    secret_value : 'latenightjaipurindianrestaurant',
    iframe_root : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3055.6277068925015!2d-105.28124028519657!3d40.01676277941357!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876bedf2eab12db3%3A0x278c7091a25fe178!2s1214%20Walnut%20St%2C%20Boulder%2C%20CO%2080302%2C%20USA!5e0!3m2!1sen!2sin!4v1592301555613!5m2!1sen!2sin',
    facebook_link:'#',
    RestaurantName:"Jaipur Indian"
};
